import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RememberDeviceService {

  public rememberDeviceChecked: boolean = false;

  constructor() { }

  /**
   * Checks if the remember device checkbox is checked, if it is, rememberThisDevice field is added
   * to the provided payload so the http interceptor will include the related http header
   * @param payload The existing payload that is to be sent to some endpoint
   */
  public checkAndApply(payload): void {
    if (this.rememberDeviceChecked) {
      payload["rememberThisDevice"] = true;
    }
  }
}